import { render, staticRenderFns } from "./PagamentosCmp.vue?vue&type=template&id=235c6d3f&scoped=true"
import script from "./PagamentosCmp.vue?vue&type=script&lang=js"
export * from "./PagamentosCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c6d3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235c6d3f')) {
      api.createRecord('235c6d3f', component.options)
    } else {
      api.reload('235c6d3f', component.options)
    }
    module.hot.accept("./PagamentosCmp.vue?vue&type=template&id=235c6d3f&scoped=true", function () {
      api.rerender('235c6d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimStatement/cmp/PagamentosCmp.vue"
export default component.exports